
export const formatPrice = (price: number) => {
    const formatted = new Intl.NumberFormat('he-IL', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(price);
    return `₪${formatted}`;
};

export const formatMeasurementUnit = (unit: string) => {
    const units = {
        'square_meter': 'מ"ר',
        'meter': 'מטר',
        'unit': 'יח\'',
        'surface': 'משטח',
        'cubic_meter': 'מ"ק',
        'kilogram': 'ק"ג',
        'liter': 'ליטר',
        'package_by_meter': 'חבילה/יחידה',
        'package_by_square_meter': 'חבילה/יחידה'
    };
    return units[unit as keyof typeof units] || unit;
};

export const formatDimensionUnit = (unit: string | null) => {
    if (!unit) return '';
    const units: Record<string, string> = {
        'cm': 'ס"מ',
        'mm': 'מ"מ',
        'm': 'מטר',
        'inch': 'אינץ\''
    };
    return units[unit] || unit;
};
